import { graphql } from "@/lib/gql/__generated__";

export const SendCustomMailSettingMutationForRequestCreate = graphql(/* GraphQL */ `
	mutation testCustomMailSendAtRequestCreate($input: CustomMailSettingTestMailInput!) {
		testCustomMailSendAtRequestCreate(input: $input) {
			userErrors
			success
		}
	}
`);
